export default __webpack_public_path__ + "static/media/bg_m.min.bf9aed6a.jpg";